import React, { ReactNode } from 'react'

type CardLoadingContextState = {
  [cardId: string]: boolean
}

type CardLoadingContextValue = {
  loadingStates: CardLoadingContextState
  setCardLoading: (cardId: string, isLoading: boolean) => void
}

const CardLoadingContext = React.createContext<CardLoadingContextValue>({
  loadingStates: {},
  setCardLoading: () => {},
})

export const useCardLoading = () => React.useContext(CardLoadingContext)

type CardLoadingProviderProps = {
  children: ReactNode
}

export const CardLoadingProvider: React.FC<CardLoadingProviderProps> = ({ children }) => {
  const [loadingStates, setLoadingStates] = React.useState<CardLoadingContextState>({})

  const setCardLoading = (cardId: string, isLoading: boolean) => {
    setLoadingStates((prev) => ({ ...prev, [cardId]: isLoading }))
  }

  const value: CardLoadingContextValue = { loadingStates, setCardLoading }

  return <CardLoadingContext.Provider value={value}>{children}</CardLoadingContext.Provider>
}
